import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Edit2, FileText } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableTransactionCashier = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllTranscationsCasher } = FetchData
    const { dataTransactionsCashier, loadingFetchAllTransactionsCashier } = fetchAllTranscationsCasher

    const { 
        handleClickFetchSpecificTransactionCashier,
        handleClickPrintReceipt
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <>
                        <TooltipInformation
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>
                )
            }
        },
        { field: "caja", headerName: "CAJA", minWidth: 250, filter: true },
        { field: "movimiento_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "idmovimiento", headerName: "ID", minWidth: 100, filter: true },
        { field: "movimiento_usuario", headerName: "USUARIO", minWidth: 150, filter: true },
        { field: "movimiento_tipo", headerName: "TIPO", minWidth: 100, filter: true },
        // { field: "movimiento_monto", headerName: "MONTO", minWidth: 150, filter: true },
        // { field: "movimiento_moneda", headerName: "MONEDA", minWidth: 150, filter: true },
        // { field: "movimiento_tipo_cambio", headerName: "CAMBIO", minWidth: 150, filter: true },
        { field: "movimiento_quetzales", headerName: "T. QUETZALES", minWidth: 150, filter: true },
        { field: "movimiento_dolares", headerName: "T. DOLARES", minWidth: 150, filter: true },
        { field: "movimiento_observaciones", headerName: "OBSERVACIONES", minWidth: 400, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idmovimiento } = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificTransactionCashier(idmovimiento, 'READONLY')}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickPrintReceipt(idmovimiento)}
                        >
                            <ListItemIcon> <FileText color="black"/> </ListItemIcon>
                            <ListItemText primary="Recibo" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllTransactionsCashier)&&(<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataTransactionsCashier}
                columnConfig={columnConfig}
            />
        </div>
    )
}
